import { Component } from 'react'
import PropTypes from 'prop-types'

class DeviceIdManager extends Component {
    constructor(props) {
        super(props)

        window.setDeviceId = this.setDeviceId
    }

    setDeviceId = (deviceId) => {
        this.props.setDeviceId(deviceId)
    }

    render() {
        return null
    }
}

DeviceIdManager.propTypes = {
    setDeviceId: PropTypes.func,
}

export default DeviceIdManager



// WEBPACK FOOTER //
// ./src/features/Backend/components/Backend/components/DeviceIdManager/component.js